import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "SidebarCommunitiesFilter"
})

export class CommunitiesSearchPipe implements PipeTransform {
    transform(value: any[], args?: any): any {

        if (!value) return null;
        if (!args) return value;

        args = args.toLowerCase();

        return value.filter((item) => {
            return item.name.toLowerCase().indexOf(args.toLowerCase()) > -1;
        });
    }
}